import React from "react";
import { Commend3Model } from "../Types";
import { getWidgetLabel, isLive } from "../Commend3Helper";
import {
  READ_ONLY_TITLE_LIVE,
  READ_ONLY_TITLE_PROMOTED,
  readOnlyNote,
} from "../Commend3Constants";

const LockIcon = () => (
  <svg
    viewBox="0 0 24 24"
    className="tw-mt-px tw-h-[17px] tw-w-[17px] tw-shrink-0"
    style={{
      stroke: "#030562",
      fill: "none",
      strokeWidth: 1.7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    aria-hidden="true"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const ModelReadOnlyBanner = ({ model }: { model: Commend3Model }) => {
  const widget = getWidgetLabel(model);
  const mapped = isLive(model);

  return (
    <div
      id="commend3-config-readonly"
      className="tw-flex tw-shrink-0 tw-items-start tw-gap-[11px] tw-rounded-[10px] tw-px-4 tw-py-3.5"
      style={{ background: "#EAF0FF", border: "1px solid #D6E0FF" }}
      role="status"
    >
      <LockIcon />
      <div className="tw-min-w-0">
        <div className="tw-text-[14px] tw-font-semibold tw-text-[#030562]">
          {mapped ? READ_ONLY_TITLE_LIVE : READ_ONLY_TITLE_PROMOTED}
        </div>
        <div
          className="tw-mt-[3px] tw-text-[13px] tw-text-[#59596E]"
          style={{ lineHeight: 1.6 }}
        >
          {readOnlyNote(widget)}
        </div>
      </div>
    </div>
  );
};

export default ModelReadOnlyBanner;
